/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Workaround for Babel restriction, see https://github.com/yahoo/babel-plugin-react-intl/issues/119
export function DynamicFormattedMessage(props) {
	return <FormattedMessage {...props} />;
}



// WEBPACK FOOTER //
// ./src/components/HelperComponent/DynamicFormattedMessage.js